.searchContainer {
  display: flex;
  flex-direction: column;
}

.searchInputContainer {
  display: flex;
  width: 100%;
}

.searchButton {
  position: relative;
  color: var(--darkSilver);
  background-color: var(--lightSilver);
  height: 2.75em;
  border: 0.05em solid var(--darkSilver);
  border-left: 0;
  width: 5em;

  &:hover {
    background-color: var(--mediumSilver);
    color: var(--black);
  }
}

.searchFiltersContainer {
  display: flex;
}

.filterSelectContainer {
  position: relative;
}

.filterSelectIcon {
  position: absolute;
  top: 0.6em;
  right: 1.75em;
  pointer-events: none;
}

.filterSelect {
  cursor: pointer !important;
  background: var(--white);
  padding: 0.5em 2.5em 0.5em 0.5em;
  margin-right: 1.125em;
  width: auto;
  height: 2.5em;
}

.enabledFilter {
  background: var(--blueActive);
  color: var(--white);

  & option {
    background: var(--white);
    color: var(--black);
  }

  & ~ span {
    color: var(--white);
  }
}

.conditionFilter {
  margin-right: 1em;
}

.roleFilters {
  display: flex;
}

.labelLegend {
  font-size: 1.125em;
  color: var(--lightGray);
  font-weight: 300;
  line-height: 2.4em;
  padding: 0;
  margin: 0;
  letter-spacing: normal;
}

.clearButtonContainer {
  display: flex;
  flex-direction: column-reverse;

  & button {
    font-weight: 600;
    height: 2.5em;
  }
}
